<template>
  <div>
    <div class="panel">
      <div class="label">申请人</div>
      <div class="value1">{{ extra.applicant }}</div>
      <div class="label">申请部门</div>
      <div class="value2">{{ extra.applyDeptName }}</div>
      <div class="label">申请人手机号</div>
      <div class="value1">{{ extra.applicantMobile }}</div>
      <div class="label">申请车型</div>
      <div class="value2">
        <DataDictFinder dictType="oa_use_car_type" :dictValue="extra.carType" />
      </div>
      <div class="label">乘车人员</div>
      <div class="value3">{{ extra.personnel }}</div>
      <div class="label">起止时间</div>
      <div class="value3">{{ extra.timeStart }} ~ {{ extra.timeEnd }}</div>
      <div class="label">用车事由</div>
      <div class="value3">{{ extra.reason }}</div>
      <div class="label">开始地址</div>
      <div class="value1">{{ extra.addressStart }}</div>
      <div class="label">结束地址</div>
      <div class="value2">{{ extra.addressEnd }}</div>
    </div>
    <Padding />
  </div>
</template>
    
  <script>
  import { mapState } from "vuex";
  import { getName } from "@/utils/clock";
  
  export default {
    computed: {
      ...mapState("approval", ["detail"]),
      extra() {
        return this.detail.extra
          ? {
              ...this.detail.extra,
            }
          : {};
      },
    },
    methods: {
      getName,
  
      renderStaff(str) {
        let msg = "";
        try {
          const list = JSON.parse(str);
          msg = list.map((item) => item.userName).join("，");
        } catch (error) {
          msg = str;
        }
  
        return msg;
      },
    },
  };
  </script>
    
    
  <style lang="less" scoped>
  .panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;
  
    & > div {
      padding: 8px;
      border-bottom: 1px solid #e8e8e8;
    }
  
    .label {
      background-color: #fafafa;
      border-right: 1px solid #e8e8e8;
      border-left: 1px solid #e8e8e8;
    }
  
    .value1 {
      grid-column-start: 2;
      grid-column-end: 4;
    }
  
    .value2 {
      grid-column-start: 5;
      grid-column-end: 7;
      border-right: 1px solid #e8e8e8;
    }
  
    .value3 {
      grid-column-start: 2;
      grid-column-end: 7;
      border-right: 1px solid #e8e8e8;
    }
  }
  </style>
    
    